import {TRANSLATION, Yup} from '@/imports-files/pages/admins/dashboard/clients/integration';


export const INITIAL_VALUES = {
  client: {
    client_integrations_attributes: [ ]
  }
};


export const VALIDATION_SCHEMA = Yup.object({});
